// extracted by mini-css-extract-plugin
export var editInput = "_ir-0";
export var editInputCompact = "_ir-2";
export var editInputLarge = "_ir-1";
export var editInputSmall = "_ir-3";